// TDE new-device approval (GOOGLE_SSO_PLAN.md, Phase 3). Sent by an unrecognized device
// (`DeviceApprovalRequired: true` on login) to ask an already-trusted device to re-wrap the
// UserKey for it. The backend binds the request to the calling session's device identifier,
// so none is sent here.
export class CreateDeviceApprovalRequest {
  // SPKI, base64 — this device's own TDE public key (`DeviceTrustService.getOrCreateDeviceKeyPair`).
  publicKey: string;
  deviceName?: string;

  constructor(publicKey: string, deviceName?: string) {
    this.publicKey = publicKey;
    this.deviceName = deviceName;
  }
}
